import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Link from 'components/common/Link/Link'
import { filterProps } from 'helpers/utils'
import { TabItem, Circle, TabSelectorWrapper, Underline } from 'components/common/Tabs/Tabs.styles'

const AccountMenuNavigation = ({
  menu,
  pathname,
  className,
  sticky
}) =>
  <Wrapper
    className={ className }
    sticky={ sticky }
    data-at-accountnavigation>
    <Underline className="underline">
      <TabSelectorWrapper className="tabs-selector">
        { menu.map(({ title, value, url }, index) =>
          <MenuLink
            className="tab-item"
            data-at-accountmenulink
            key={ title }
            to={ url }
            isActive={ url === pathname }>
            { title }
            { value &&
              <Circle>{ value }</Circle>
            }
          </MenuLink>
        )
        }
      </TabSelectorWrapper>
    </Underline>
  </Wrapper>

AccountMenuNavigation.propTypes = {
  className: PropTypes.string,
  menu: PropTypes.arrayOf(PropTypes.shape()),
  pathname: PropTypes.string,
  sticky: PropTypes.bool
}

export default AccountMenuNavigation

const Wrapper = styled.div`
  ${Mixin.responsive('padding', '60px 0 40px', '25px 0 30px')}
  ${Media.mobile`
    ${props => props.sticky && css`
      display: none;
    `}
  `}
`

const propsToRemove = [
  'isActive'
]

const MenuLink = TabItem.withComponent((props) => <Link { ...filterProps(props, propsToRemove) } />)
